import { QueryResult, useQuery } from '@apollo/client'
import { Country, PyramidForecastValueSelectorQuery, PyramidForecastValueSelectorQueryVariables } from '../../../types'
import { PYRAMID_FORECAST_SELECTOR } from '../Queries'

export const usePyramidForecastSelectorYearAndMonth = (
  companyId: string,
  country: Country,
): QueryResult<PyramidForecastValueSelectorQuery, PyramidForecastValueSelectorQueryVariables> => {
  return useQuery<PyramidForecastValueSelectorQuery, PyramidForecastValueSelectorQueryVariables>(PYRAMID_FORECAST_SELECTOR, {
    variables: { companyId, country },
  })
}
